/**
 * Tabs Component.
 * For toggle tab; switch experience between personal, business and others
 * toggle labelArray data struture
 *  [{
 *    key,
 *    label,
 *    priority,
 *    href,
 *  }, ...]
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _toNumber from 'lodash/toNumber';

// Helper
import { trackLink } from '../../../lib/analytics-helper';
import { TAB } from '../../constants/PropTypesShapes';

class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
    };

    // binding this function
    this.renderLabel = this.renderLabel.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  // Handle Click event with Tracking FPTI as a Param.
  handleClick(e, index) {
    this.setState({
      selected: index.priority,
    });
    if (this.props.trackLink && this.props.trackLink.id && this.props.trackLink.link) {
      trackLink(this.props.trackLink);
    }
    if (this.props.onClick) {
      this.props.onClick(index);
    }
  }

  handleKeyPress(e, tab) {
    if (e.which === 13) {
      this.handleClick(e, tab);
    }
  }

  // Sort the display sequence by priority index
  sortTabNameList() {
    return this.props.labelArray.sort((tab1, tab2) => (
      _toNumber(tab1.priority) - _toNumber(tab2.priority)
    ));
  }

  // Add active for selection toggle
  renderActiveClass(index) {
    return (this.state.selected === index ? 'active ' : '') + this.props.tabClass;
  }

  // render Each content toggle
  renderLabel(tab, index) {
    const activeClass = this.renderActiveClass(index);
    const Tag = 'a'; // Tag from button to a for home page navigation

    const tabAttribs = {
      id: `tab-linkContent__${tab.key}`,
      className: `btn vx_btn-link linkContent ${activeClass}`,
      onClick: (e) => this.handleClick(e, tab),
      onKeyPress: (e) => this.handleKeyPress(e, tab),
      tabIndex: 0,
      href: tab.href,
    };

    if (this.props.hashAnchor) {
      tabAttribs.href = `#${tab.key}`;
    }

    if (this.state.selected === index) {
      tabAttribs['aria-current'] = 'page';
    }

    return (
      <li key={index} className="tab">
        <Tag {...tabAttribs}>
          {tab.label}
        </Tag>
      </li>
    );
  }

  // render content toggles with container
  renderTabs() {
    return (
      <ul className="tabs-panel">
        {this.sortTabNameList().map(this.renderLabel)}
      </ul>
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.renderTabs()}
      </div>
    );
  }
}

// Tabs Props Types.
Tabs.propTypes = {
  className: PropTypes.string,
  labelArray: PropTypes.arrayOf(PropTypes.shape(TAB)).isRequired,
  onClick: PropTypes.func,
  trackLink: PropTypes.shape({
    id: PropTypes.string,
    link: PropTypes.string,
  }),
  selected: PropTypes.number,
  tabClass: PropTypes.string,
  hashAnchor: PropTypes.bool,
};

Tabs.defaultProps = {
  className: 'tabs-container',
  onClick: () => {},
  trackLink: {},
  selected: 0,
  tabClass: '',
  hashAnchor: false,
};

export default Tabs;
